import classnames from 'classnames'
import type { PropsWithChildren, FC, HTMLAttributes } from 'react'
import React from 'react'

import styles from './Cell.module.css'

type Props = HTMLAttributes<HTMLDivElement> & {
  aside?: boolean
  children?: React.ReactNode
  className?: string
  dataTestId?: string
  direction?: 'initial'
  noBorder?: boolean
  noPadding?: boolean
  noPaddingX?: boolean
  noPaddingY?: boolean
  ref?: React.Ref<HTMLDivElement>
  secondary?: boolean
  stickyLeft?: boolean
}

export const Cell: FC<PropsWithChildren<Props>> = React.memo<Props>(
  React.forwardRef(
    (
      {
        dataTestId,
        children,
        aside,
        secondary,
        noPadding,
        noBorder,
        className,
        noPaddingX,
        noPaddingY,
        stickyLeft,
        direction = null,
        ...other
      },
      ref
    ) => {
      return (
        <div
          {...other}
          data-testid={dataTestId}
          ref={ref}
          className={classnames(className, styles.Column, {
            [styles.ColumnAside]: aside,
            [styles.ColumnSecondary]: secondary,
            [styles.ColumnNoPadding]: !!noPadding,
            [styles.ColumnNoBorder]: !!noBorder,
            [styles.ColumnNoPaddingX]: !!noPaddingX,
            [styles.ColumnNoPaddingY]: !!noPaddingY,
            [styles.ColumnStickyLeft]: !!stickyLeft,
            [styles.DirectionInitial]: direction === 'initial'
          })}
        >
          {children}
        </div>
      )
    }
  )
)
